import { Component, OnInit } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";

// SERVICES
import { RolesService } from "src/app/services/roles.service";
import { GrupoService } from "src/app/services/grupos.service";
import {UserService} from 'src/app/services/user.service';
import {HelpersService} from 'src/app/services/helpers.service'

@Component({
  selector: "app-usuario",
  templateUrl: "./usuario.component.html",
  styleUrls: ["./usuario.component.scss"],
})
export class UsuarioComponent implements OnInit {
  roles;
  grupos;
  tipo_docs: any = [{ name: "V" }, { name: "J" }, { name: "E" }, { name: "G" }];
  usuarioForm = this.fb.group({
    correo: ["", [Validators.required, Validators.email, Validators.max(30)]],
    clave: ["", [Validators.required, Validators.minLength(8)]],
    nombre: ["", [Validators.required]],
    apellido: ["", [Validators.required]],
    telefono: ["", [Validators.required, Validators.pattern("^[0-9]*$")]],
    documento: ["", [Validators.required, Validators.pattern("^[0-9]*$")]],
    tipo_documento: ["", [Validators.required]],
    estatus: ["Activo"],
    nombre_equipo: ["", [Validators.required]],
    nm: ["", [Validators.required]],
    intentos: [0],
    ad: [0],
    borrado: [0],
    id_grupos: [""],
    id_roles: ["", [Validators.required]],
    id_usuarios_creador: [sessionStorage.getItem("id_usuario")],
  });
  constructor(
    public dialogRef: MatDialogRef<UsuarioComponent>,
    private fb: FormBuilder,
    private rolesService: RolesService,
    private gruposService: GrupoService,
    public userService: UserService,
    public helpers: HelpersService
  ) {
    this.rolesService.getRoles().subscribe((data: any) => {
      console.log("Obteniendo roles disponibles",data.payload) 
      this.roles = data.payload;
    });
    this.gruposService.obtenerTodos().subscribe((data: any) => {
      console.log("Obteniendo grupos disponibles",data.payload)
      this.grupos = data.payload;
    });
  }

  ngOnInit(): void {}

  save(){
    console.log("Enviando formulario",this.usuarioForm.value)
    this.userService.createUser(this.usuarioForm.value).subscribe(
      (res:any) => {
        console.log("Respuesta recibida",res.payload)
        this.helpers.snackbar("Usuario creado con éxito.");
        this.dialogRef.close(true)
      },err => {
        console.log("ERROR al crear el usuario:", err.error.payload)
        this.helpers.snackbar(err.error.payload)
      }
    );
  }
}
